import React from 'react'
import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import { FloatField } from 'storfox-form-fields'

import CountryField from '~/components/Fields/CountryField'
import PhoneNumberField from '~/components/Fields/PhoneNumberField'
import TextField from '~/components/Fields/TextField'
import { CardHeader } from '~/components/Cards'
import EmailField from '~/components/Fields/EmailField'

function ShipmentFromAddress () {
  return (
    <Card>
      <CardHeader title="Pickup address" />
      <Divider />
      <CardContent>
        <Grid container={true} spacing={3}>
          <Grid item={true} xs={12} lg={6}>
            <TextField
              data-cy="fromAddress.firstName"
              name="fromAddress.firstName"
              label="First name" />
          </Grid>

          <Grid item={true} xs={12} lg={6}>
            <TextField
              data-cy="fromAddress.lastName"
              name="fromAddress.lastName"
              label="Last name"
            />
          </Grid>

          <Grid item={true} xs={12}>
            <EmailField
              data-cy="fromAddress.email"
              name="fromAddress.email"
              label="Email"
            />
          </Grid>

          <Grid item={true} xs={12}>
            <PhoneNumberField
              data-cy="fromAddress.mobile"
              name="fromAddress.mobile"
              label="Phone"
            />
          </Grid>

          <Grid item={true} xs={12}>
            <TextField
              data-cy="fromAddress.address"
              name="fromAddress.address"
              label="Address"
              multiline={true}
              minRows={3}
            />
          </Grid>

          <Grid item={true} xs={12}>
            <TextField
              data-cy="fromAddress.region"
              name="fromAddress.region"
              label="Region/Neighbouring/State"
            />
          </Grid>

          <Grid item={true} xs={12} lg={6}>
            <TextField
              data-cy="fromAddress.city"
              name="fromAddress.city"
              label="City"
            />
          </Grid>

          <Grid item={true} xs={12} lg={6}>
            <TextField
              data-cy="fromAddress.zipcode"
              name="fromAddress.zipcode"
              label="Zipcode"
            />
          </Grid>

          <Grid item={true} xs={12}>
            <CountryField
              data-cy="fromAddress.country"
              name="fromAddress.country"
              label="Country"
            />
          </Grid>

          <Grid item={true} xs={6}>
            <FloatField
              data-cy={`fromAddress.longitude`}
              name={`fromAddress.longitude`}
              label="Longitude"
              inputProps={{ decimalScale: 30 }}
            />
          </Grid>

          <Grid item={true} xs={6}>
            <FloatField
              data-cy={`fromAddress.latitude`}
              name={`fromAddress.latitude`}
              label="Latitude"
              inputProps={{ decimalScale: 30 }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ShipmentFromAddress
